import { Button, Modal } from "antd"
import React, { useState } from "react"

interface DeleteProjectTypeModalProps {
  open: boolean
  /** True only for a Change Request whose amounts were added to the contract. */
  isIncludedInContract: boolean
  onCancel: () => void
  onDelete: (reverseContract: boolean) => Promise<void> | void
}

export function DeleteProjectTypeModal({
  open,
  isIncludedInContract,
  onCancel,
  onDelete
}: DeleteProjectTypeModalProps) {
  const [saving, setSaving] = useState(false)

  const remove = async (reverseContract: boolean) => {
    if (saving) return
    setSaving(true)
    try {
      await onDelete(reverseContract)
    } finally {
      setSaving(false)
    }
  }

  const footer = isIncludedInContract
    ? [
        <Button key="cancel" onClick={onCancel} disabled={saving}>
          Cancel
        </Button>,
        <Button key="keep" onClick={() => void remove(false)} disabled={saving}>
          Delete &amp; Keep Contract Unchanged
        </Button>,
        <Button
          key="update"
          type="primary"
          danger
          loading={saving}
          onClick={() => void remove(true)}
        >
          Delete &amp; Update Contract
        </Button>
      ]
    : [
        <Button key="cancel" onClick={onCancel} disabled={saving}>
          Cancel
        </Button>,
        <Button
          key="delete"
          type="primary"
          danger
          loading={saving}
          onClick={() => void remove(false)}
        >
          Delete
        </Button>
      ]

  return (
    <Modal
      title="Delete Project Type"
      open={open}
      onCancel={onCancel}
      maskClosable={false}
      footer={footer}
    >
      {isIncludedInContract ? (
        <p>
          This Project Type is included in the Contract Value. Deleting it will
          remove its contract impact. Do you want to update the Contract Value?
        </p>
      ) : (
        <p>
          This will remove the project type and all of its milestones from the
          project.
        </p>
      )}
    </Modal>
  )
}
